import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
//primereact
import { Row } from "primereact/row";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { ColumnGroup } from "primereact/columngroup";
//components
import Modal from "../../../../../../../components/modal/Modal";
//utils
import { formatCurrency } from "../../../../../../../utils/formatCurrency";
import { postRenegotiations } from "../../../../../../../services/Contracts/postRenegotiations";
import { postEvaluateRenegotiation } from "../../../../../../../services/Contracts/postEvaluateRenegotiation";
//utils
import { formatDate } from "../../../../../../../utils/formatDate";
import { getParcel } from "../../../../../../../services/Parcel/getParcel";
import { useAppContext } from "../../../../../../../context/AppContext";

const Renegotiations = ({
  setActiveIndex,
  id,
  setModalActionsActive,
  setDefaultIndexColorActive,
  setTypeActionContract,
  setIdRenegotiate
}) => {
  const { permissions } = useAppContext();
  const [totalCost, setTotalCost] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [tableDataModal, setTableDataModal] = useState([]);
  const [tableDataModalFormReneg, setTableDataModalFormReneg] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);

  const { data: dataRenegotiations, refetch } = useQuery(
    `renegotiations${id}`,
    () =>
      postRenegotiations({
        sale_id: id,
        status: "all",
      }),
    { enabled: !!permissions?.includes("53") }
  );

  const {
    data: parcels,
    refetch: refetchParcels,
    isLoading: isLoadingParcel,
  } = useQuery({
    queryKey: [`parcels${id}`],
    queryFn: () => getParcel(id),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    enabled: !!permissions?.includes("36")
  });


  const columnsRenegotiateForm = [
    {
      field: "value",
      header: "Valor Renegociado",
      body: (rowData) => {
        return formatCurrency(rowData.value);
      },
    },
    {
      field: "discount",
      header: "Desconto",
      body: (rowData) => {
        return formatCurrency(rowData.discount);
      },
    },
    {
      field: "tariffs_fee",
      header: "Taxas/ Tarifas",
      body: (rowData) => {
        return formatCurrency(rowData.discount);
      },
    },
    {
      field: "entry",
      header: "Entrada",
      body: (rowData) => {
        return formatCurrency(rowData.entry);
      },
    },
    {
      field: "date_entry",
      header: "Data Entrada",
      body: (rowData) => {
        return formatDate(rowData.date_entry);
      },
    },
    {
      field: "how_many_installments",
      header: "Quantidade de Parcelas Financiamento",
    },
    {
      field: "value_installments",
      header: "Valor da Parcela Financiamento",
      body: (rowData) => {
        return formatCurrency(rowData.value_installments);
      },
    },
    {
      field: "date_first_installment",
      header: "Data 1º Financiamento",
      body: (rowData) => {
        return formatDate(rowData.date_first_installment);
      },
    },
    { field: "interest_rate", header: "Taxa de Juros" },
  ];

  const columnsModal = [
    { field: "id", header: "ID" },

    { field: "sequence_number", header: "Nº Parcela" },
    { field: "description.name", header: "Descrição" },
    {
      field: "due_date",
      header: "Vencimento",
      body: (rowData) => {
        return formatDate(rowData.due_date);
      },
    },
    {
      field: "value",
      header: "Valor da Parcela",
      body: (rowData) => {
        return formatCurrency(rowData.value);
      },
    },
  ];

  const columnsRenegotiate = [
    { field: "id", header: "Cód." },
    {
      field: "value",
      header: "Valor Renegociado",
      body: (rowData) => {
        return formatCurrency(rowData.value);
      },
    },
    {
      field: "discount",
      header: "Desconto",
      body: (rowData) => {
        return formatCurrency(rowData.discount);
      },
    },
    {
      field: "entry",
      header: "Entrada",
      body: (rowData) => {
        return formatCurrency(rowData.entry);
      },
    },
    {
      field: "value_installments",
      header: "Valor da Parcela Financiamento",
      body: (rowData) => {
        return formatCurrency(rowData.value_installments);
      },
    },
    { field: "how_many_installments", header: "Quantidade de Parcelas" },
    { field: "interest_rate", header: "Taxa de Juros" },

    {
      field: "created_at",
      header: "Data Realizada",
      body: (rowData) => {
        return formatDate(rowData.created_at);
      },
    },
    {
      field: "status",
      header: "Status",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            labelClass = "badge bg-warning";
            labelText = "Em Análise";
            break;
          case 2:
            labelClass = "badge bg-danger";
            labelText = "Recusada";
            break;
          case 1:
            labelClass = "badge bg-success";
            labelText = "Aprovada";
            break;
          default:
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "10px",
              marginLeft: "5px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
  ];

  const transformedData = dataRenegotiations?.map((item) => ({
    id: item.id,
    value: item.value,
    discount: item.discount,
    entry: item.entry,
    value_installments: item.value_installments,
    how_many_installments: item.how_many_installments,
    interest_rate: item.interest_rate,
    created_at: item.created_at,
    status: item.status,
  }));


  const generateContractReneg = (id) => {
    console.log("Rengotiate: ", id)
  }

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column
          footer="Total:"
          colSpan={4}
          footerStyle={{ textAlign: "right" }}
        />
        <Column footer={formatCurrency(totalCost)} />
      </Row>
    </ColumnGroup>
  );

  // const onSubmit = async (data) => {
  //   data = {
  //     ...data,
  //     sale_id: id,
  //     value_land: dataRenegotiations.contract_value,
  //     value_cost: dataRenegotiations.totalCost,
  //     value_armotized: dataRenegotiations.totalPay,
  //   };
  //   // console.log(data);
  //   setLoadingButton(true);
  //   const notification = toast.loading("Por favor aguarde...");
  //   try {
  //     // await postCancellationFn(data);
  //     toast.update(notification, {
  //       render: "Distrato enviada para análise!",
  //       autoClose: 1000,
  //       theme: "colored",
  //       type: "success",
  //       isLoading: false,
  //     });
  //     setLoadingButton(false);
  //   } catch (error) {
  //     toast.update(notification, {
  //       render: error.message,
  //       autoClose: 1000,
  //       theme: "colored",
  //       type: "error",
  //       isLoading: false,
  //     });
  //     setLoadingButton(false);
  //     return;
  //   }
  //   form.reset();
  //   form.clearErrors();
  //   form.setValue("obs", "");
  //   form.setValue("value_cost", dataRenegotiations.totalCost);
  //   form.setValue(
  //     "pay_back",
  //     dataRenegotiations.payBack < 0 ? 0 : dataRenegotiations.payBack
  //   );
  // };

  function getInstallmentsById(data, id, form) {
    if (form === "id") {
      const item = data.find((entry) => entry.id === id);
      return item ? item.installments : [];
    } else {
      const item = data.find((entry) => entry.id === id);
      if (item) {
        const { installments, ...rest } = item;
        return rest;
      } else {
        return [];
      }
    }
  }

  const handleReview = (e, data) => {
    e.preventDefault();

    const result = getInstallmentsById(dataRenegotiations, data.id, "id");
    const resultForm = getInstallmentsById(dataRenegotiations, data.id, "data");

    const totalValue = result?.reduce(
      (sum, installment) => sum + installment.value,
      0
    );
    setTotalCost(totalValue);
    setTableDataModal(result);
    setTableDataModalFormReneg([resultForm]);
    setShowModal(true);
  };

  const handleEvaluete = async (data, status) => {
    //    console.log(tableDataModal);
    //    console.log(tableDataModalFormReneg);

    let obj = {
      renegotiation_id: tableDataModalFormReneg[0].id,
      status: status,
    };
    let messageConfirm;
    if (status === 1) {
      messageConfirm = "Renegociação aprovada com sucesso!";
    } else {
      messageConfirm = "Renegociação recusada com sucesso!";
    }

    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      await postEvaluateRenegotiation(obj);
      toast.update(notification, {
        render: messageConfirm,
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoadingButton(false);
    } catch (error) {
      toast.update(notification, {
        render: error.message,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
      return;
    } finally {
      refetchParcels();
      refetch();
    }
    setShowModal(false);
  };

  return (
    <>
      <div className="row">
        <div className="card-border me-2 my-2">
          <div className="title-container">
            <p>
              {" "}
              <i className="fa-solid fa-power-off me-2"></i>Renegociações do
              Contrato
            </p>
          </div>
          <div className="row mt-2 p-4">
            <h4 className="text-success">
              {" "}
              <i className="fa-solid fa-hand-holding-dollar mx-2"></i>
              Renegociações
            </h4>
            <hr />
            {transformedData ? (
              <DataTable
                rows={5}
                paginator
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="single"
                rowsPerPageOptions={[5, 25, 100]}
                value={transformedData}
                // loading={isLoadingCancellations}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                {columnsRenegotiate.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    body={col.body}
                    field={col.field}
                    header={col.header}
                  />
                ))}
                <Column
                  header="Ações"
                  body={(rowData) =>
                    rowData.status === 0 && permissions && permissions.includes("65") ? ( //Visualizar Renegociações
                      <div className="text-center">
                        <button
                          className="btn btn-success btn-btn-sm"
                          onClick={(e) => handleReview(e, rowData)}
                        >
                          <i className="fa-solid fa-eye"></i>
                        </button>
                      </div>
                    ) : rowData.status === 1 && permissions && permissions.includes("61") ? ( //Imprimir Contratos 
                      <div className="text-center">
                        <button
                          className="btn btn-info btn-btn-sm"
                          onClick={() => {
                            setIdRenegotiate(rowData.id)
                            setTypeActionContract("renegociacao")
                            setModalActionsActive(true);
                            setDefaultIndexColorActive(1);
                          }}
                        >
                          <i className="fa fa-print"></i>
                        </button>
                      </div>
                    ) : (
                      <></>
                    )
                  }
                />
              </DataTable>
            ) : (
              <Skeleton width="100%" height="150px" />
            )}
          </div>
        </div>
      </div>

      <Modal
        visible={showModal}
        position="center"
        onHide={() => setShowModal(false)}
        dynamicWidth={window.innerWidth <= 992 ? "85vw" : "60vw"}
        dynamicTitle="Renegociação"
      >
        <div className="row mt-2 p-4">
          <h4 className="text-success">
            {" "}
            <i className="fa-solid fa-hand-holding-dollar mx-2"></i>
            Parcelas Renegociadas
          </h4>
          <DataTable
            rows={5}
            stripedRows
            showGridlines
            sortMode="multiple"
            selectionMode="single"
            footerColumnGroup={footerGroup}
            value={tableDataModal}
            emptyMessage="Nenhuma Informação foi encontrada."
            tableStyle={{ minWidth: "0.8rem", fontSize: "0.72rem" }}
          >
            {columnsModal.map((col) => (
              <Column
                sortable
                key={col.field}
                body={col.body}
                field={col.field}
                header={col.header}
              />
            ))}
          </DataTable>
        </div>

        <div className="row mt-2 p-4">
          <h4 className="text-success">
            {" "}
            <i className="fa-solid fa-hand-holding-dollar mx-2"></i>
            Forma Renegociada
          </h4>
          <DataTable
            rows={5}
            stripedRows
            showGridlines
            sortMode="multiple"
            selectionMode="single"
            value={tableDataModalFormReneg}
            emptyMessage="Nenhuma Informação foi encontrada."
            tableStyle={{ minWidth: "0.8rem", fontSize: "0.72rem" }}
          >
            {columnsRenegotiateForm.map((col) => (
              <Column
                sortable
                key={col.field}
                body={col.body}
                field={col.field}
                header={col.header}
              />
            ))}
          </DataTable>
        </div>
        <div className="row mt-4 justify-content-center">
          {permissions && permissions.includes("65") && ( //Aprovar Renegociações
            <div className="col-md-6 text-center">
              <Button
                label="Aprovar"
                className="bg-success w-50"
                icon="fa-solid fa-check"
                loading={loadingButton}
                onClick={(rowData) => handleEvaluete(rowData, 1)}
                rounded
              />
            </div>
          )}
          {permissions && permissions.includes("66") && ( //Recusar Renegociações
            <div className="col-md-6 text-center">
              <Button
                label="Recusar"
                className="bg-danger w-50"
                icon="fa-solid fa-ban"
                loading={loadingButton}
                onClick={(rowData) => handleEvaluete(rowData, 2)}
                style={{ border: "none" }}
                rounded
              />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default Renegotiations;
